import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-detail-covoiturage',
  templateUrl: './detail-covoiturage.component.html',
  styleUrls: ['./detail-covoiturage.component.scss']
})
export class DetailCovoiturageComponent {

  
  constructor(@Inject(MAT_DIALOG_DATA) public element: any, private router: Router, public snackBar: MatSnackBar, public sanitizer: DomSanitizer, public dialogRef: MatDialogRef<DetailCovoiturageComponent>)
   {  }


  isUpdate: boolean = false;
  IsWait: boolean = true;


  onConfirm(): void {

    this.dialogRef.close(true);
  }



  updateUser() {
    this.isUpdate = true
  }



  cancelUpdateUser() {
    this.isUpdate = false
  }



  openNewTab() {
    console.log(this.element)
    const url = `https://maps.google.com/maps?&z=7&q=${this.element.station.latitude}+${this.element.station.longitude}`
    window.open(url, '_blank');
  }



  onNoClick(): void {
    this.dialogRef.close(false);
  }


  openSnackBarDone(message: string) {
    this.snackBar.open(message, "X", {
      panelClass: ['sucess-snackbar'],
      duration: 20000,
    });
  }



  openSnackBarError(message: string) {
    this.snackBar.open(message, "X", {
      panelClass: ['error-snackbar'],
      duration: 2000,
    });
  }


  copyMessage(val: string){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.openSnackBarDone("L'adresse de déstination est copiée avec succès")
  }


  callPersonne(element: any){
   location.href = `tel:${element?.created_by.phonenumber}`
  }


  openConnexion() {
    this.dialogRef.close(false);
    this.router.navigateByUrl(`/connexion`)
  }

  openInscription() {
    this.dialogRef.close(false);
    this.router.navigateByUrl(`/admin/subscribe?covoiturage=true`)
  }

  getDateFormat(str : string){
    var newString = str.replace('-','/').replace('-', '/').replace('T',' ').replace(':00Z','');
   return  newString
  }

  

}
